import { ArrowDown } from "lucide-react";
import { HOSPITAL_BG, PHOTO_HERO, waLink } from "../../lib/constants";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-20 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url(${HOSPITAL_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
          filter: "blur(14px) saturate(1.1)",
          transform: "scale(1.08)",
        }}
      />
      <div className="absolute inset-0 bg-white/65 pointer-events-none" />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(1200px 600px at 20% 30%, rgba(13,71,161,0.10), transparent 60%), radial-gradient(900px 500px at 85% 70%, rgba(0,137,123,0.10), transparent 65%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8 w-full py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center bg-[#0D47A1]/10 border border-[#0D47A1]/20 rounded-full px-4 py-1.5 text-sm font-semibold text-[#0D47A1] mb-6">
              Cirurgião Torácico · Feira de Santana, BA
            </div>
            <h1 className="font-poppins font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight mb-4 text-[#0D47A1]">
              Derrame Pleural? <br />
              <span className="text-[#00897B]">O Cirurgião Torácico é o especialista que você precisa</span>
            </h1>
            <p className="text-lg md:text-xl text-[#212121]/80 mb-5 font-semibold leading-snug">
              Diagnóstico preciso, drenagem segura e tratamento definitivo. Respire melhor a partir de agora.
            </p>
            <p className="text-base md:text-lg text-[#212121]/65 mb-8 leading-relaxed max-w-xl">
              Você sente falta de ar, faz uma radiografia e descobre que há líquido nos pulmões — Derrame Pleural.
              De repente, tudo fica confuso: O que é? De onde veio? É grave? Preciso de cirurgia? Um especialista
              real responde todas essas perguntas. O Cirurgião Torácico não apenas identifica o problema, mas
              oferece as soluções mais completas e eficazes: desde drenagem simples até cirurgia por técnicas
              minimamente invasivas. A boa notícia: derrame pleural é tratável, e você pode respirar melhor muito
              em breve. Você encontrou o especialista certo aqui.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-primary-cta"
                className="bg-[#0D47A1] text-white font-poppins font-bold px-8 py-4 rounded-full hover:bg-[#00897B] transition-all duration-200 text-center shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                AGENDAR AVALIAÇÃO DE DERRAME PLEURAL
              </a>
              <a
                href="#diagnostico"
                data-testid="hero-secondary-cta"
                className="text-[#0D47A1] border-2 border-[#0D47A1]/30 font-poppins font-semibold px-8 py-4 rounded-full hover:bg-[#0D47A1]/8 hover:border-[#0D47A1]/60 transition-all duration-200 text-center flex items-center justify-center gap-2"
              >
                Como funciona o tratamento
                <ArrowDown size={16} />
              </a>
            </div>
            <div className="flex flex-wrap gap-10 pt-8 border-t border-[#0D47A1]/15">
              <div>
                <span className="font-poppins font-bold text-3xl text-[#0D47A1]">Especialista</span>
                <div className="text-[#212121]/55 text-sm">em Cirurgia Torácica</div>
              </div>
              <div>
                <span className="font-poppins font-bold text-3xl text-[#0D47A1]">VATS</span>
                <div className="text-[#212121]/55 text-sm">Técnica minimamente invasiva</div>
              </div>
            </div>
          </div>

          <div className="relative order-1 lg:order-2 flex justify-center lg:justify-end items-end">
            <div className="relative w-full max-w-sm lg:max-w-xl">
              <img
                alt="Dr. Mateus Marques - Cirurgião Torácico especializado em Derrame Pleural"
                className="w-full object-contain object-center"
                loading="eager"
                src={PHOTO_HERO}
                style={{
                  maxHeight: "680px",
                  filter: "drop-shadow(rgba(13, 71, 161, 0.15) 0px 20px 60px)",
                }}
                width="576"
                height="680"
              />
              <div className="absolute top-8 -right-2 bg-[#00897B] rounded-2xl p-4 shadow-xl">
                <div className="font-poppins font-bold text-lg text-white leading-tight">Expertise em</div>
                <div className="font-poppins font-bold text-xl text-white leading-tight">Derrame Pleural</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
